<script setup lang="ts">
import CircleProgress from '~/components/loaders/CircleProgress.vue'
import { useResultStore } from '~/store/result'

defineOptions({
	name: 'LoaderResults',
})

const props = withDefaults(
	defineProps<{
		title?: string
		description?: string
		showCustomMessage?: boolean
		classContainer?: string
	}>(),
	{
		title: undefined,
		description: undefined,
		showCustomMessage: false,
		classContainer: 'flex justify-center items-center pt-9 sm:pt-24 pb-64 sm:pb-56',
	},
)

const resultStore = useResultStore()
const { t: $t } = useI18n()

const getNumbers = computed(() => {
	if (resultStore.numbers === null) return []
	let numbers = resultStore.numbers.first.map((num) => num)
	if (resultStore.numbers.last !== null) {
		const last = resultStore.numbers.last.map((num) => num)
		numbers = [...numbers, ...last]
	}
	return numbers
})
</script>

<template>
	<section :class="classContainer">
		<div class="text-center space-y-7 smm:max-w-sm w-full">
			<CircleProgress
				class="text-primary-800 w-24 h-24"
				:numbers="getNumbers"
			/>
			<div
				v-if="props.showCustomMessage"
				class="text-secondary-50 space-y-2"
			>
				<h3 class="text-[18px] font-bold leading-6">{{ title ?? $t('Analyzing History') }}</h3>
				<p class="leading-5">{{ description ?? `${$t('Searching through all recorded years')}...` }}</p>
			</div>
			<div
				v-else
				class="text-secondary-50 font-semibold text-lg leading-8"
			>
				<p class="text-secondary-50 font-semibold text-lg leading-8">{{ $t('Crunching those lucky numbers') }}...</p>
				<p class="text-secondary-50 font-semibold text-lg leading-8">{{ $t('just a sec') }}!</p>
			</div>
		</div>
	</section>
</template>
